import { gql, useQuery } from '@apollo/client';

import {
  LwcDetails,
  LwcDetailsVariables,
} from '../../../graphql/athena/queries/__generated__/LwcDetails';

export const LWC_DETAILS_QUERY = gql`
  query LwcDetails($agentCustomerUuid: String!) {
    odProtosListingsServicesListwithcertaintyproduct {
      getLwcDetails(input: { agentCustomerId: $agentCustomerUuid }) {
        lwcDetails {
          lwcProduct {
            id
            sellerLeadToken
            state
            agentNote
            cepNote
            leadPassBackNote
            listingId
            presentationType
            timestamps {
              key
              timestamp
            }
          }
          agentLead {
            id
            assignedBrokerageId
            state
          }
          listing {
            id
            state
            listingPrice
            soldPrice
            grossCommission
            timestamps {
              state
              timestamp
            }
          }
        }
      }
    }
  }
`;

export const useLwcDetailsQuery = (agentCustomerUuid: string) => {
  const { data, loading, error } = useQuery<LwcDetails, LwcDetailsVariables>(LWC_DETAILS_QUERY, {
    context: {
      clientName: 'athena',
    },
    variables: { agentCustomerUuid },
    fetchPolicy: 'cache-first',
  });

  const lwcDetails =
    data?.odProtosListingsServicesListwithcertaintyproduct?.getLwcDetails?.lwcDetails;

  const details = lwcDetails?.map((detail) => {
    return {
      token: detail?.lwcProduct?.sellerLeadToken,
      state: detail?.lwcProduct?.state,
      id: detail?.lwcProduct?.id,
      agentLeadId: detail?.agentLead?.id,
      assignedBrokerageId: detail?.agentLead?.assignedBrokerageId,
      listingId: detail?.listing?.id,
      listingPrice: detail?.listing?.listingPrice,
      soldPrice: detail?.listing?.soldPrice,
      grossCommission: detail?.listing?.grossCommission,
    };
  });

  return { details, loading, error };
};
